import React from 'react';
import './AboutPage.css';
import Particles from 'react-particles-js';
import Contact from '../../../Components/Contact/Contact';

const AboutPage = () => {
  return (
    <>
      {/* This is contact page Wrapper!!!! */}
      <div id="contactPage" className="particleJSPart">
        <Particles
          params={{
            "particles": {
              "number": {
                "value": 60,
                "density": {
                  "enable": false
                }
              },
              "color": {
                "value": '#FF9800'
              },
              "size": {
                "value": 10,
                "random": true,
                "anim": {
                  "speed": 4,
                  "size_min": 0.3
                }
              },
              "line_linked": {
                "enable": false
              },
              "move": {
                "random": true,
                "speed": 1,
                "direction": "top",
                "out_mode": "out"
              }
            },
            "interactivity": {
              "events": {
                "onhover": {
                  "enable": true,
                  "mode": "bubble"
                },
                "onclick": {
                  "enable": true,
                  "mode": "repulse"
                }
              },
              "modes": {
                "bubble": {
                  "distance": 50,
                  "duration": 2,
                  "size": 0,
                  "opacity": 0
                },
                "repulse": {
                  "distance": 400,
                  "duration": 4
                }
              }
            }
          }} />
      </div>
      <div className="particlePart">
        <Contact></Contact>
      </div>
    </>
  );
};

export default AboutPage;